export default {
	namespaced: true,
	state: {
		resultsList: [],
		inputs: {
			rider: {
				metric: '',
				us: '',
				unit: "kg"
			},
			gear: {
				metric: '',
				us: '',
				unit: "kg"
			},
			luggage: {
				metric: '',
				us: '',
				unit: "kg"
			},
			farkles: {
				metric: '',
				us: '',
				unit: "kg"
			},
			target: {
				metric: '',
				us: '',
				unit: "km"
			}
		},
		oem: false,
		unit: 'metric',
        chartsUrl: ''
	},
	getters: {
		/**
         * Get current results
         * @param state
         * @returns {*|Array|string}
         */
        getResults: state => {
            return state.resultsList;
        },
        /**
         * Get current inputs
         * @param state
         * @returns {*|Array|string}
         */
        getInputs: state => {
            return state.inputs;
        },
        /**
         * Get measurement unit
         * @param state
         * @returns {*|Array|string}
         */
        getMeasurement: state => {
            return state.unit;
        },

        /**
         * Get oem value
         * @param state
         * @returns {*|Array|string}
         */
        getOem: state => {
            return state.oem;
        },
        /**
         * Get charts url value
         * @param state
         * @returns {*|Array|string}
         */
        getChartsUrl: state => {
            return state.chartsUrl;
        },
	},
	mutations: {
		/**
         * Update updateMeasurement
         * @param state
         * @param data
         */
        updateMeasurement:(state, value) => {
        	return state.unit = value;
        },

        /**
         * Update OEM
         * @param state
         * @param data
         */
        updateOem:(state, value) => {
        	return state.oem = value;
        },

		/**
         * Update addCalculatedFields
         * @param state
         * @param data
         */
		addFields: (state, data = state.resultsList) => {
			state.resultsList = data.map(item => {
				item["wetweightcalc"] = {
					metric: item["bikewtwet"].metric > 0 ? item["bikewtwet"].metric : item["bikewtwetest"].metric > 0 ? item["bikewtwetest"].metric : 0,
					us: item["bikewtwet"].us > 0 ? item["bikewtwet"].us : item["bikewtwetest"].us > 0 ? item["bikewtwetest"].us : 0,
                    measurement: {us: 'lb', metric: 'kg'}
				};
				item["powertoweight"] = {
					metric: item["wetweightcalc"].metric == 0 && item["engmaxpwr"].metric == 0 ? 0 : item["engmaxpwr"].metric / item["wetweightcalc"].metric,
					us: item["wetweightcalc"].us == 0 && item["engmaxpwr"].us == 0 ? 0 : item["engmaxpwr"].us / item["wetweightcalc"].us,
                    measurement: {us: 'HP/lb', metric: 'kW/kg'}
				};
                item["bikefueleconcomb"] = {
                    metric: !state.oem && item["fuellydata"].metric > 0 ? item["fuellydata"].metric : item["bikefueleconspec"].metric > 0 ? item["bikefueleconspec"].metric : item["fuellydata"].metric > 0 ? item["fuellydata"].metric : 0,
                    us: !state.oem && item["fuellydata"].us > 0 ? item["fuellydata"].us : item["bikefueleconspec"].us > 0 ? item["bikefueleconspec"].us : item["fuellydata"].us > 0 ? item["fuellydata"].us : 0,
                    measurement: {us: 'mpg', metric: 'L/100km'}

                    };
                item["fuelrequired"] = {
                    metric: (item["bikefueleconcomb"].metric / 100) * Number(state.inputs.target.metric),
                    us: (item["bikefueleconcomb"].us > 0) ? Number(state.inputs.target.us) / item["bikefueleconcomb"].us : 0,
                    measurement: {us: 'gal', metric: 'L'}
                };        
                item["extrafuelrequired"] = {
                    metric: item["fuelrequired"].metric > item["bikefuelcap"].metric ? item["fuelrequired"].metric - item["bikefuelcap"].metric : 0,
                    us: item["fuelrequired"].us > item["bikefuelcap"].us ? item["fuelrequired"].us - item["bikefuelcap"].us : 0,
                    measurement: {us: 'gal', metric: 'L'}
                };

                item["extrafuelweight"] = {
                    metric: item["extrafuelrequired"].metric > 0 ? item["extrafuelrequired"].metric * 0.75 + 5 : 0,
                    us: item["extrafuelrequired"].us > 0 ? item["extrafuelrequired"].us * 6 + 11 : 0,
                    measurement: {us: 'lb', metric: 'kg'}
                };

                item["fullbikeweight"] = {
                    metric: item["wetweightcalc"].metric + item["extrafuelweight"].metric + Number(state.inputs.luggage.metric) + Number(state.inputs.farkles.metric),
                    us: item["wetweightcalc"].us + item["extrafuelweight"].us + Number(state.inputs.luggage.us) + Number(state.inputs.farkles.us),
                    measurement: {us: 'lb', metric: 'kg'}
                };

                item["riderfullweight"] = {
                    metric: Number(state.inputs.rider.metric) + Number(state.inputs.gear.metric),
                    us: Number(state.inputs.rider.us) + Number(state.inputs.gear.us),
                    measurement: {us: 'lb', metric: 'kg'}
                };
        
                item["fullbikeweightwrider"] = {
                    metric: item["fullbikeweight"].metric + item["riderfullweight"].metric,
                    us: item["fullbikeweight"].us + item["riderfullweight"].us,
                    measurement: {us: 'lb', metric: 'kg'}
                };
          
                item["powertofullweight"] = {
                    metric: item["engmaxpwr"].metric / item["fullbikeweightwrider"].metric,
                    us: item["engmaxpwr"].us / item["fullbikeweightwrider"].us,
                    measurement: {us: 'HP/lb', metric: 'kW/kg'}
                };
                item["engpwrdensity"] = {
                    metric: (item["engmaxpwr"].metric / item["engdisp"].metric) * 1000,
                    us: item["engmaxpwr"].us / item["engdisp"].us,
                    measurement: {us: 'HP/CI', metric: 'W/cc'}
                };
                item["bikewtwetest"] = {
                    metric: item["bikewtwet"].metric === 0 ? item["bikewtdry"].metric + 4 + item["bikefuelcap"].metric * 0.75 : 0,
                    us: item["bikewtwet"].us === 0 ? item["bikewtdry"].us + 9 + item["bikefuelcap"].us * 6 : 0,
                    measurement: {us: 'lb', metric: 'kg'}

                };
                item["range"] = {
                    metric: item["bikefueleconcomb"].metric == 0 ? 0 : (item["bikefuelcap"].metric / item["bikefueleconcomb"].metric) * 100,
                    us: item["bikefuelcap"].us * item["bikefueleconcomb"].us,
                    measurement: {us: 'mi', metric: 'km'}
                };
                
                return item
			});	
		},
		/**
         * Update Inputs
         * @param state
         * @param data
         */
        addInputs: ( state, data ) => {
        	if (state.unit == "metric") {
				state.inputs[data.name] = {
					metric: parseFloat(data.value),
					us: state.inputs[data.name].unit == "kg" ? parseFloat(data.value) * 2.20462262185 : parseFloat(data.value) * 0.62137119
				}
			} else {
				state.inputs[data.name] = {
					metric: state.inputs[data.name]['unit'] == "kg" ? parseFloat(data.value) / 2.20462262185 : parseFloat(data.value) / 0.62137119,
					us:  parseFloat(data.value)
				}
			}
        },

        /**
         * Update Charts params
         * @param state
         * @param data
        */
        addChartParams: ( state, data ) => {
            state.chartsUrl = `https://www.advspecs.com/charts?x=${data.x}&y=${data.y}&z=${data.z}&unit=${state.unit}&rider=${state.inputs.rider[state.unit]}&gear=${state.inputs.gear[state.unit]}&luggage=${state.inputs.luggage[state.unit]}&farkles=${state.inputs.farkles[state.unit]}&target=${state.inputs.target[state.unit]}`;
        }

	},
	actions: {
		/**
         * Update measurement
         * @param context
         * @param organisation
         */
        updateMeasurement(context, value) {
        	context.commit('updateMeasurement', value);
        },

        /**
         * Update oem
         * @param context
         * @param organisation
         */
        updateOem(context, value) {
        	context.commit('updateOem', value);
        	context.commit('addFields');
        },

		/**
         * Update resultsList
         * @param context
         * @param organisation
         */
        updateResultsList(context, list) {
   			context.commit('addFields', list);
        },

        /**
	    //    * Update Inputs
	    //    * @param context
	    //    * @param organisation
	    //    */
        updateInputs(context, data) {
   			context.commit('addInputs', data);
   			context.commit('addFields');
        },

        /**
	    //    * Process router params
	    //    * @param context
	    //    * @param organisation
	    //    */

        getRouterQuery(context, query) {
        	let values = Object.keys(query);

        	if(values.length == 0) {
        		// if not provided manually set these
        		query = {
        			rider: 0,
        			gear: 0,
        			luggage: 0,
        			farkles: 0,
        			target: 0
        		}
        	}
        	// update inputs
        	for(let [key, value] of Object.entries(query)) {
        		if(key == 'unit') {
        			context.commit('updateMeasurement', value) 
        		} else {
	        		let data = {};
	    			data['name'] =  key;
	    			data['value'] =  value;
	    			context.commit('addInputs', data);
        		}
            }
        },

        getChartsRouterQuery(context, query) {
            let values = Object.keys(query);

            // update inputs
            for(let [key, value] of Object.entries(query)) {
                if(key == 'unit') {
                    context.commit('updateMeasurement', value) 
                } else {
                    let data = {};
                    data['name'] =  key;
                    data['value'] =  value;
                    context.commit('addInputs', data);
                }
            }
        },

        /**
        //    * Update Charts URL
        //    * @param context
        //    * @param charts
        //    */
        updateChartsUrl(context, data) {
            context.commit('addChartParams', data)
        }

	}
}